/**
 * @typedef {import('./strategyTypes').PersistentStorage} PersistentStorage
 * @typedef {import('./strategyTypes').PersistentStorageStrategy} PersistentStorageStrategy
 */

/** fallback no op strategy */
const noOp = () => {};
const noOpNull = () => null;
const noOpEmptyObject = () => ({});

/** @type {PersistentStorage} */
const noOpStorage = {
  getAllItems: noOpEmptyObject,
  getItem: noOpNull,
  setItem: noOp,
  removeItem: noOp,
  clear: noOp,
  get length() {
    return 0;
  }
};

/** @type {PersistentStorageStrategy} */
export const noOpStrategy = {
  name: 'noOpStrategy',
  isSupported: () => true,
  storageInstance: () => noOpStorage
};
